module.exports = __webpack_public_path__ + "img/about-family-company.jpg?ca6480635787ebd718ec5e731b7b9c5f";